import {useCountedItemEdit} from '../useCountedItem/useCountedItemEdit'

export const useItemsEditedEdit = (itemId, inputAmount, refreshCounting) => {
    return useCountedItemEdit({
        itemId,
        initialAmount: inputAmount,
        refreshCallback: refreshCounting,
        editFields: ['amount']
    })
}